import { Fragment } from 'react';

import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SmallGridRowIcons = ({ relayTeam, onDeleteClicked }) => (
  <Fragment>
    {relayTeam.canBeDeleted === true &&
      <button
        type='button'
        className={global.IconButton}
        onClick={() => onDeleteClicked(relayTeam)}>
        <DeleteIcon />
      </button>
    }
  </Fragment>
);

//TODO tablet view
const SmallGridRow = ({ relayTeam, onDeleteClicked }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}>
      <span></span>&nbsp;
      <SmallGridRowIcons
        relayTeam={relayTeam}
        onDeleteClicked={onDeleteClicked} />
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Team Name
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {relayTeam?.orgUnitName || ''}
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Org Unit Code
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {relayTeam?.orgUnitCode || ''}
        </div>
      </div>
    </div>
  </div>
);

const LaneSheetMeetEventAddRelayTeamsSmallGrid = ({ isLoading, gridData, onDeleteClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}><div className={global.SmallTableRowLabels}>Loading...</div></div>
        </div>
      ) : Array.isArray(gridData) && gridData?.length > 0
        ? gridData?.map((relayTeam, i) =>
          <SmallGridRow
            key={i}
            relayTeam={relayTeam}
            onDeleteClicked={onDeleteClicked} />)
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}><div className={global.SmallTableRowLabels}>No Results</div></div>
          </div>
        )
    }
  </div>
);

export default LaneSheetMeetEventAddRelayTeamsSmallGrid;